(function($){
  $(document).ready(function(){

    $('body').css('visibility', 'visible');


    $("#insta-gallery-feed-1").append("<div class='insta-block'><div class='insta-text'><i class='fab fa-instagram'></i>#FireDisc</div></div>");

    // var height = $('.slider-layout').offset().top;
    // $('.textured-bg').css("height", height - 34);

    $('.video-container').on('click', function(e){
      $('.video-embed').addClass('is-active');
      // $(".video-embed iframe")[0].src += "&autoplay=1&rel=0&modestbranding=1";
      $('.video-container .centered-text-container').css('display', 'none');
      $('.video-container').css({'background':'none', 'height':'auto'});

      var vidDefer = document.getElementsByTagName('iframe');
      for (var i=0; i<vidDefer.length; i++) {
        if(vidDefer[i].getAttribute('data-src')) {
          vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
        }
      }
      e.preventDefault();
    });

    // Start Defer YouTube videos
      // function init() {
      //
      // }
      // window.onload = init;

      // End Defer YouTube videos

      // Start Sliders

      $('.home-slide-container').slick({
        arrows: false,
        dots: true,
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 8000,
      });

      $('.testimonial-slider').slick({
        arrows: false,
        dots: true,
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 8000,
      });

      $('.hero-slider').slick({
        arrows: false,
        dots: false,
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 8000
      });

      // $('.woocommerce-product-gallery__wrapper').slick({
      //  slidesToShow: 1,
      //  slidesToScroll: 1,
      //  arrows: false,
      //  fade: true,
      //  asNavFor: '.flex-control-nav'
      // });
      //
      // $('.flex-control-nav').slick({
      //   arrows: true,
      //   dots: false,
      //   speed: 1000,
      //   slidesToShow: 4,
      //   slidesToScroll: 1,
      //   asNavFor: '.woocommerce-product-gallery__wrapper',
      //   autoplay: false,
      //   infinite: true,
      //   nextArrow: '<i class="fa fa-arrow-left"></i>',
      //   prevArrow: '<i class="fa fa-arrow-right"></i>'
      // });

      // End Sliders

      $('#menu-sidebar li.menu-item-has-children').prepend('<i class="fas fa-plus"></i>');

      $('#menu-sidebar li.menu-item-has-children i').parent().on('click', function(e){
          // e.preventDefault();
          $(this).toggleClass('expanded');
          $(this).find('i').toggleClass('fa-plus fa-minus');
      });

      $('.selected-menu li.menu-item-has-children').prepend('<i class="fas fa-plus"></i>');

      $('.selected-menu li.menu-item-has-children i').parent().on('click', function(e){
          // e.preventDefault();
          $(this).toggleClass('expanded');
          $(this).find('i').toggleClass('fa-plus fa-minus');
      });

      //Cooks It All Menu
      $('#cia-toggle').on('click', function(e){
        $('.cia-dd').toggleClass('hide');

      });

      $(document).mouseup(function(e)
      {
          var container = $(".cia-dd");

          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0)
          {
              $('.cia-dd').addClass('hide');
          }
      });

      // $(window).on('load', function() {
      //     $('body').show();
      // });
      $('.masonry-grid').masonry({
          // options
          itemSelector: '.masonry-item',
          columnWidth: '.grid-sizer',
          percentPosition: true
      });

      // Jump Icon
      $(".jump-icon").click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#flex-content").offset().top
        }, 1000);
      });

      //Pro Ambassador Product Slider
      $('.video-products .product-container').slick({
        arrows: false,
        dots: true,
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 4000
      });

      $('#js-rotating').css('display', 'unset');
      $("#js-rotating").Morphext({
        // The [in] animation type. Refer to Animate.css for a list of available animations.
        animation: "fadeIn",
        // An array of phrases to rotate are created based on this separator. Change it if you wish to separate the phrases differently (e.g. So Simple | Very Doge | Much Wow | Such Cool).
        separator: ",",
        // The delay between the changing of each phrase in milliseconds.
        speed: 2000,
        complete: function () {
            // Called after the entrance animation is executed.
//                 $( ".animated" ).addClass('fadeIn');
          setTimeout(function () {
              $('.animated').show().addClass('fadeOut');}, 1500
          );
        }
     });

  });
})(jQuery);
